export function initEditorFunctionality() {
  let swReady = false;
  const handler = (event: MessageEvent) => {
    const allowedOrigins = [
      /^https:\/\/websim\.ai$/,
      /^http:\/\/websim\.localhost:8080$/,
      /^https:\/\/[a-z0-9-]+\.websim\.pages\.dev$/,
    ];
    if (!allowedOrigins.some((origin) => origin.test(event.origin))) {
      return;
    }

    if (event.data.type === "EDITOR_SETUP_SW") {
      // console.log('setting up sw', navigator.serviceWorker);
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/___editor_service_worker.js?v=current")
          .then((registration) => {
            // console.log('sw register hit', registration);
            if (registration.active) {
              swReady = true;
              // TODO: send message back?
            }
            registration.addEventListener("activate", () => {
              swReady = true;
              // TODO: send message back?
            });
          });
      }
    }
    if (event.data.type === "EDITOR_SET_FILES") {
      // Forward to SW if it's ready
      if (!swReady) {
        // TODO: why is swReady not set?
        console.warn("swReady not set, why?");
      }
      if (navigator.serviceWorker.controller) {
        // console.log('forwarding to SW', event.data);
        navigator.serviceWorker.controller.postMessage(event.data);
      }
    }
  };

  window.addEventListener("message", handler);
}
